import client from '../base-api';

const serviceURL = '/deleted-records';

const deletedRecordsService = {

    // Office
    getDeletedOfficeList(filterData: any) {
        return client.get(`${serviceURL}/office`, {params: filterData});
    },
    undeleteOffice(officeId: number) {
        return client.put(`${serviceURL}/office-undelete/${officeId}`);
    },

    // Client
    getDeletedClientList(filterData: any) {
        return client.get(`${serviceURL}/client`, {params: filterData});
    },
    undeleteClient(clientId: number) {
        return client.put(`${serviceURL}/client-undelete/${clientId}`);
    },

    // User
    getDeletedUserList(filterData: any) {
        return client.get(`${serviceURL}/user`, {params: filterData});
    },
    undeleteUser(userId: number) {
        return client.put(`${serviceURL}/user-undelete/${userId}`);
    },

    // Unemployed
    getDeletedUnemployedList(filterData: any) {
        return client.get(`${serviceURL}/unemployed`, {params: filterData});
    },
    undeleteUnemployed(unemployedId: number) {
        return client.put(`${serviceURL}/unemployed-undelete/${unemployedId}`);
    },


    // COURSES
    // Private coaching
    getDeletedCoursePrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/course-private-coaching`, {params: filterData});
    },
    undeleteCoursePrivateCoaching(courseId: number) {
        return client.put(`${serviceURL}/course-private-coaching-undelete/${courseId}`);
    },


    // Group coaching
    getDeletedCourseGroupCoachingList(filterData: any) {
        return client.get(`${serviceURL}/course-group-coaching`, {params: filterData});
    },
    undeleteCourseGroupCoaching(courseId: number) {
        return client.put(`${serviceURL}/course-group-coaching-undelete/${courseId}`);
    },


    // Private learning coaching
    getDeletedCoursePrivateLearningCoachingList(filterData: any) {
        return client.get(`${serviceURL}/course-private-learning-coaching`, {params: filterData});
    },
    undeleteCoursePrivateLearningCoaching(courseId: number) {
        return client.put(`${serviceURL}/course-private-learning-coaching-undelete/${courseId}`);
    },

}

export default deletedRecordsService;